// NOXEN Theme JS

document.addEventListener('DOMContentLoaded', () => {

  // Cart drawer
  // NOTE: cart-drawer's innerHTML gets replaced after add-to-cart (see
  // refreshCartDrawer below), so anything inside it (e.g. #cart-close) must
  // be handled via delegation on document, not a direct listener - a direct
  // listener would be attached to a node that gets thrown away.
  function openCart() {
    document.getElementById('cart-drawer')?.classList.add('open');
    document.getElementById('cart-overlay')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    document.getElementById('cart-drawer')?.classList.remove('open');
    document.getElementById('cart-overlay')?.classList.remove('open');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) openCart();
    if (e.target.closest('#cart-close')) closeCart();
    if (e.target.id === 'cart-overlay') closeCart();
  });

  // Color selector
  document.querySelectorAll('.color-swatch').forEach(swatch => {
    swatch.addEventListener('click', () => {
      document.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');
      const color = swatch.dataset.color;
      const label = document.getElementById('selected-color');
      if (label) label.textContent = color;
      // swap gallery images
      const imgs = document.querySelectorAll('[data-color-img]');
      imgs.forEach(img => {
        img.style.display = img.dataset.colorImg === color ? 'block' : 'none';
      });
      const badge = document.getElementById('color-badge');
      if (badge) badge.textContent = color;
    });
  });

  // Size selector - matches against whichever option slot (1/2/3) holds the
  // size value, since "Rozmiar" isn't always option2 - on single-option
  // products (only Rozmiar, no Color) it's option1.
  function findVariantBySize(size) {
    if (!window.productVariants) return null;
    return window.productVariants.find(v => v.option1 === size || v.option2 === size || v.option3 === size);
  }

  // Size selector - initialize variant-id on page load
  const activeBtn = document.querySelector('.size-btn.active');
  if (activeBtn) {
    const variantIdInput = document.getElementById('variant-id');
    const activeVariant = findVariantBySize(activeBtn.dataset.size);
    if (activeVariant && variantIdInput) variantIdInput.value = activeVariant.id;
  }

  // Size selector - use event delegation
  document.addEventListener('click', (e) => {
    const sizeBtn = e.target.closest('.size-btn');
    if (sizeBtn) {
      document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
      sizeBtn.classList.add('active');
      const selectedSize = document.getElementById('selected-size');
      const variantIdInput = document.getElementById('variant-id');
      const size = sizeBtn.dataset.size;
      if (selectedSize) selectedSize.value = size;
      const variant = findVariantBySize(size);
      if (variant && variantIdInput) variantIdInput.value = variant.id;
    }
  });

  // Gallery thumbnails
  document.querySelectorAll('.gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const mainImg = document.getElementById('gallery-main-img');
      if (mainImg && thumb.dataset.src) mainImg.src = thumb.dataset.src;
    });
  });

  // Tab switcher
  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      document.getElementById('tab-' + target)?.classList.add('active');
    });
  });

  // Sticky ATC
  const atcSection = document.getElementById('atc-anchor');
  const stickyAtc = document.getElementById('sticky-atc');
  if (atcSection && stickyAtc) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (!e.isIntersecting) stickyAtc.classList.add('visible');
        else stickyAtc.classList.remove('visible');
      });
    }, { threshold: 0 });
    obs.observe(atcSection);
  }

  // Discount popup
  const popup = document.getElementById('discount-popup');
  const popupClose = document.getElementById('popup-close');
  const popupSkip = document.getElementById('popup-skip');
  if (popup && !sessionStorage.getItem('nox_popup_shown')) {
    setTimeout(() => {
      popup.classList.add('open');
      sessionStorage.setItem('nox_popup_shown', '1');
    }, 2500);
  }
  function closePopup() { popup?.classList.remove('open'); }
  popupClose?.addEventListener('click', closePopup);
  popupSkip?.addEventListener('click', closePopup);
  popup?.addEventListener('click', e => { if (e.target === popup) closePopup(); });

  // Qty controls in cart - updates quantity server-side via /cart/change.js
  document.addEventListener('click', e => {
    if (e.target.closest('.qty-control')) {
      const btn = e.target.closest('.qty-control');
      const line = btn.closest('[data-line]')?.dataset.line;
      const valEl = btn.parentElement.querySelector('.qty-val');
      if (!valEl || !line) return;
      let v = parseInt(valEl.textContent) || 1;
      if (btn.dataset.action === 'plus') v = Math.min(v + 1, 99);
      if (btn.dataset.action === 'minus') v = Math.max(v - 1, 1);
      btn.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: v })
      }).then(res => res.json())
        .then(() => window.location.reload())
        .catch(() => {
          alert('Nie udało się zaktualizować ilości');
          btn.disabled = false;
        });
    }

    // Remove from cart
    if (e.target.closest('.cart-line-remove')) {
      e.preventDefault();
      const btn = e.target.closest('.cart-line-remove');
      const line = btn.dataset.line;
      if (!line) return;
      btn.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: 0 })
      }).then(res => res.json())
        .then(() => refreshCartDrawer())
        .catch(err => {
          alert('Nie udało się usunąć z koszyka');
          btn.disabled = false;
        });
    }
  });

  // Mobile nav toggle
  const mobileToggle = document.getElementById('mobile-nav-toggle');
  const mobileNav = document.getElementById('mobile-nav');

  // Init: hide menu on page load
  if (mobileNav) {
    mobileNav.style.setProperty('transform', 'translateY(calc(-100vh + 64px))', 'important');
  }

  function closeMobileNav() {
    mobileNav?.classList.remove('open');
    if (mobileNav) {
      mobileNav.style.transition = 'none';
      mobileNav.style.setProperty('transform', 'translateY(calc(-100vh + 64px))', 'important');
      // Trigger reflow
      void mobileNav.offsetHeight;
      mobileNav.style.transition = 'transform 0.3s ease';
    }
  }
  function toggleMobileNav(e) {
    e.stopPropagation();
    if (mobileNav?.classList.contains('open')) {
      closeMobileNav();
    } else {
      mobileNav?.classList.add('open');
      if (mobileNav) {
        mobileNav.style.transition = 'none';
        mobileNav.style.setProperty('transform', 'translateY(0)', 'important');
        // Trigger reflow
        void mobileNav.offsetHeight;
        mobileNav.style.transition = 'transform 0.3s ease';
      }
    }
  }
  mobileToggle?.addEventListener('click', toggleMobileNav);
  // Close when clicking on a link
  mobileNav?.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeMobileNav);
  });
  // Close when clicking outside (on the page)
  document.addEventListener('click', (e) => {
    if (!e.target.closest('#mobile-nav') && !e.target.closest('#mobile-nav-toggle')) {
      closeMobileNav();
    }
  });

  // Scroll-based header style
  window.addEventListener('scroll', () => {
    const header = document.getElementById('header');
    if (header) {
      header.style.background = window.scrollY > 50
        ? 'rgba(10,10,10,0.99)'
        : 'rgba(10,10,10,0.97)';
    }
  }, { passive: true });

  // Fade-up on scroll
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.style.opacity = '1';
        e.target.style.transform = 'translateY(0)';
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity .6s ease, transform .6s ease';
    observer.observe(el);
  });

  // Newsletter form
  document.querySelectorAll('.newsletter-form').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const btn = form.querySelector('.newsletter-submit');
      const original = btn.textContent;
      btn.textContent = 'Subscribed!';
      btn.style.background = '#1a1a1a';
      setTimeout(() => {
        btn.textContent = original;
        btn.style.background = '';
        form.reset();
      }, 3000);
    });
  });

  // Product form: add to cart / buy now
  // Uses relative URLs on purpose - this store has a primary custom domain,
  // and Shopify 302-redirects any *.myshopify.com request back to it,
  // which turns the POST into a GET and 404s on /cart/add. Relative URLs
  // always hit whatever domain the customer is actually on.
  const variantInput = document.getElementById('variant-id');

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] })
    }).then(res => {
      if (!res.ok) return res.json().then(err => { throw new Error(err.description || 'Nie udało się dodać do koszyka'); });
      return res.json();
    });
  }

  function refreshCartDrawer() {
    return fetch(location.pathname + location.search)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newDrawer = doc.getElementById('cart-drawer');
        const oldDrawer = document.getElementById('cart-drawer');
        if (newDrawer && oldDrawer) {
          oldDrawer.innerHTML = newDrawer.innerHTML;
        }
        const newCartBtn = doc.querySelector('[data-cart-open]');
        document.querySelectorAll('[data-cart-open]').forEach(btn => {
          if (newCartBtn) {
            btn.innerHTML = newCartBtn.innerHTML;
            btn.setAttribute('aria-label', newCartBtn.getAttribute('aria-label'));
          }
        });
      });
  }

  document.addEventListener('click', (e) => {
    const atcBtn = e.target.closest('.btn-atc');
    if (atcBtn && variantInput && !atcBtn.disabled) {
      e.preventDefault();
      const variantId = variantInput.value;
      const original = atcBtn.textContent;
      atcBtn.disabled = true;
      addToCart(variantId, 1)
        .then(() => refreshCartDrawer())
        .then(() => {
          openCart();
          atcBtn.textContent = 'Dodano!';
          atcBtn.style.background = '#1a6b2e';
        })
        .catch(err => {
          alert(err.message);
        })
        .finally(() => {
          setTimeout(() => {
            atcBtn.textContent = original;
            atcBtn.style.background = '';
            atcBtn.disabled = false;
          }, 1500);
        });
      return;
    }

    const buynowBtn = e.target.closest('.btn-buynow');
    if (buynowBtn && variantInput && !buynowBtn.disabled) {
      e.preventDefault();
      const variantId = variantInput.value;
      buynowBtn.disabled = true;
      const original = buynowBtn.textContent;
      buynowBtn.textContent = '...';
      addToCart(variantId, 1)
        .then(() => {
          window.location.href = '/checkout';
        })
        .catch(err => {
          alert(err.message);
          buynowBtn.disabled = false;
          buynowBtn.textContent = original;
        });
    }
  });

});
